import { lazy } from "react";
import { authRoles } from "../../auth/authRoles";

const FormBasic = lazy(() => import("./FormBasic"));

const ActionBarForm = lazy(() => import("./ActionBarForm"));

const LayoutForm = lazy(() => import("./LayoutForm"));

const MultiColumnForms = lazy(() => import("./MultiColumnForms"));

const InputGroupForm = lazy(() => import("./InputGroupForm"));

const FormValidation = lazy(() => import("./FormValidation"));

const FormsWizard = lazy(() => import("./FormsWizard"));

const TagInput = lazy(() => import("./TagInput"));

const FormEditor = lazy(() => import("./FormEditor"));

// -----------------------------------------------------
// -----------------FORMULARIOS-------------------------
const ContainerCreate = lazy(() =>
  import("../motoland/containers/ContainerCreate")
);
const ContainerShow = lazy(() =>
  import("../motoland/containers/ContainerShow")
);
const ContainerDetail = lazy(() =>
  import("../motoland/containers/ContainerDetail")
);
const ContainerEdit = lazy(() =>
  import("../motoland/containers/ContainerEdit")
);
const ContainerUnits = lazy(() =>
  import("../motoland/containers/ContainerUnits")
);
const ContainerEliminate = lazy(() =>
  import("../motoland/containers/ContainerEliminate")
);
const ContainerExtracted = lazy(() =>
  import("../motoland/containers/ContainerExtracted")
);
const ContainerTransitInventory = lazy(() =>
  import("../motoland/containers/ContainerTransitInventory")
);
const AssemblyProjectionPage = lazy(() =>
  import("../motoland/containers/AssemblyProjectionPage")
);
const MonthlyPlanningReport = lazy(() =>
  import("../motoland/armado/MonthlyPlanningReport")
);
const AssemblyLineDashboard = lazy(() =>
  import("../motoland/armado/AssemblyLineDashboard")
);
const ContainerDistribution = lazy(() =>
  import("../motoland/containers/ContainerDistribution")
);

const DistributionCreate = lazy(() =>
  import("../motoland/distributions/DistributionCreate")
);
const DistributionShow = lazy(() =>
  import("../motoland/distributions/DistributionShow")
);
const DistributionEdit = lazy(() =>
  import("../motoland/distributions/DistributionEdit")
);
const DistributionUnits = lazy(() =>
  import("../motoland/distributions/DistributionUnits")
);

const AssemblyCreate = lazy(() =>
  import("../motoland/ensamblajes/AssemblyCreate")
);
const AssemblyShow = lazy(() => import("../motoland/ensamblajes/AssemblyShow"));
const WorkCodesShow = lazy(() =>
  import("../motoland/ensamblajes/WorkCodesShow")
);
const AssemblyEdit = lazy(() => import("../motoland/ensamblajes/AssemblyEdit"));
const AssemblyUnits = lazy(() =>
  import("../motoland/ensamblajes/AssemblyUnits")
);
const AssemblyReject = lazy(() =>
  import("../motoland/ensamblajes/AssemblyReject")
);
const SurveyTemplates = lazy(() =>
  import("../motoland/encuestas/SurveyTemplates")
);
const SurveyFill = lazy(() => import("../motoland/encuestas/SurveyFill"));
const SupervisorTargets = lazy(() =>
  import("../motoland/encuestas/SupervisorTargets")
);
const SupervisorCompliance = lazy(() =>
  import("../motoland/encuestas/SupervisorCompliance")
);
const SurveyTracking = lazy(() =>
  import("../motoland/encuestas/SurveyTracking")
);

const VehicleCreate = lazy(() => import("../motoland/vehiculos/VehicleCreate"));
const VehicleEdit = lazy(() => import("../motoland/vehiculos/VehicleEdit"));
const VehicleShow = lazy(() => import("../motoland/vehiculos/VehicleShow"));
const VehicleSend = lazy(() => import("../motoland/vehiculos/VehicleSend"));
const VehicleChangeData = lazy(() =>
  import("../motoland/vehiculos/VehicleChangeData")
);
const VehicleSendMassive = lazy(() =>
  import("../motoland/vehiculos/VehicleSendMassive")
);
const VehicleOrder = lazy(() => import("../motoland/vehiculos/VehicleOrden"));
const VehicleShowOrder = lazy(() =>
  import("../motoland/vehiculos/VehicleShowOrder")
);
const VehicleSendDistribution = lazy(() =>
  import("../motoland/vehiculos/VehicleSendDistribution")
);
const VehicleSendAssembly = lazy(() =>
  import("../motoland/vehiculos/VehicleSendAssembly")
);
const VehicleFollow = lazy(() => import("../motoland/vehiculos/VehicleFollow"));
const VehicleReceptionDistribution = lazy(() =>
  import("../motoland/vehiculos/VehicleReceptionDistribution")
);
const VehicleReceptionAssembly = lazy(() =>
  import("../motoland/vehiculos/VehicleReceptionAssembly")
);
const VehicleUnlink = lazy(() => import("../motoland/vehiculos/VehicleUnlink"));
const VehicleFormEdit = lazy(() =>
  import("../motoland/vehiculos/VehicleFormEdit")
);
const VehicleCostManager = lazy(() =>
  import("../motoland/vehiculos/VehicleCostManager")
);

const AgentShow = lazy(() => import("../motoland/agentes/AgentShow"));
const AgentAnnex = lazy(() => import("../motoland/agentes/AgentAnnex"));
const AgentCreate = lazy(() => import("../motoland/agentes/AgentCreate"));
const AgentEdit = lazy(() => import("../motoland/agentes/AgentEdit"));
const AgentDocuments = lazy(() => import("../motoland/agentes/AgentDocuments"));
const AgentUnits = lazy(() => import("../motoland/agentes/AgentUnits"));
const AgentPay = lazy(() => import("../motoland/agentes/AgentPay"));
const AgentReport = lazy(() => import("../motoland/agentes/AgentReport"));
const AgentReportAgent = lazy(() =>
  import("../motoland/agentes/AgentReportAgent")
);
const AgentReportGlobal = lazy(() =>
  import("../motoland/agentes/AgentReportGlobal")
);
const AgentReportSinFacturar = lazy(() =>
  import("../motoland/agentes/AgentReportSinFacturar")
);
const AgentReportCredit = lazy(() =>
  import("../motoland/agentes/AgentReportCredit")
);
const AgentDetailUnits = lazy(() =>
  import("../motoland/agentes/AgentDetailUnits")
);
const AgentReportVoucher = lazy(() =>
  import("../motoland/agentes/AgentReportVoucher")
);

const AgentUnitsIncome = lazy(() =>
  import("../motoland/agentes/AgentUnitsIncome")
);

const AgentSalesHistory = lazy(() =>
  import("../motoland/agentes/AgentSalesHistory")
);

const SucursalIndex = lazy(() =>
  import("../motoland/sucursales/SucursalIndex")
);
const SucursalCreate = lazy(() =>
  import("../motoland/sucursales/SucursalCreate")
);

const CreateBill = lazy(() => import("../motoland/facturar/CreateBill"));

const BillSell = lazy(() => import("../motoland/facturar/BillSell"));
const BillReject = lazy(() => import("../motoland/facturar/BillReject"));
const BillList = lazy(() => import("../motoland/facturar/BillList"));
const BillListPending = lazy(() =>
  import("../motoland/facturar/BillListPending")
);
const BillDetail = lazy(() => import("../motoland/facturar/BillDetail"));
const BillGenerator = lazy(() => import("../motoland/facturar/BillGenerator"));
const BillReport = lazy(() => import("../motoland/facturar/BillReports"));
const BillReportBySupervisor = lazy(() =>
  import("../motoland/facturar/BillReportForSupervisor")
);
const RaffleTickets = lazy(() => import("../motoland/raffle/RaffleTickets"));

const PayIndex = lazy(() => import("../motoland/pagos/PayIndex"));
const PayUnit = lazy(() => import("../motoland/pagos/PayUnit"));
const PayShow = lazy(() => import("../motoland/pagos/PayShow"));
const PayVoucher = lazy(() => import("../motoland/pagos/PayVoucher"));
const PayVoucherDetail = lazy(() =>
  import("../motoland/pagos/PayDetailVoucher")
);

const UserCreate = lazy(() => import("../motoland/usuarios/UserCreate"));
const UserEdit = lazy(() => import("../motoland/usuarios/UserEdit"));
const UserShow = lazy(() => import("../motoland/usuarios/UserShow"));
const UserPermissions = lazy(() =>
  import("../motoland/usuarios/UserPermissions")
);

const UserSettingsCreate = lazy(() =>
  import("../motoland/users_settings/UserSettingsCreate")
);
const UserSettings = lazy(() =>
  import("../motoland/users_settings/UserSettings")
);
const UserManager = lazy(() =>
  import("../motoland/users_settings/UserManager")
);

const OrdersViewer = lazy(() => import("../motoland/orders/OrdersViewer"));
const OrdersPhoto = lazy(() => import("../motoland/orders/OrdersPhoto"));
const OrderCreate = lazy(() => import("../motoland/orders/OrderCreate"));
const OrderCreateUsed = lazy(() => import("../motoland/orders/OrderUsed"));
const OrdersDispatch = lazy(() => import("../motoland/orders/OrdersDispatch"));
const OrdersPreview = lazy(() => import("../motoland/orders/OrdersPreview"));
const OrdersEdit = lazy(() => import("../motoland/orders/OrdersEdit"));
const OrdersMasterControl = lazy(() =>
  import("../motoland/orders/OrdersMasterControl")
);
const OrdersAccounting = lazy(() =>
  import("../motoland/orders/OrdersAccounting")
);
const OrdersDispatchGenerate = lazy(() =>
  import("../motoland/orders/OrdersDispatchGenerate")
);
const OrdersDispatchLoad = lazy(() =>
  import("../motoland/orders/OrdersDispatchLoad")
);
const OrdersDispatchPreview = lazy(() =>
  import("../motoland/orders/OrderDispatchPreview")
);
const MyOrders = lazy(() => import("../motoland/orders/MyOrders"));
const OrderLoaded = lazy(() => import("../motoland/orders/OrderLoaded"));
const OrdersDetailsByBill = lazy(() =>
  import("../motoland/orders/OrdersDetailsByBill")
);
const DetailOrder = lazy(() => import("../motoland/orders/DetailOrder"));
const ApproveOrder = lazy(() => import("../motoland/orders/ApproveOrder"));
const LoadOrders = lazy(() => import("../motoland/orders/LoadOrders"));
const RequestPending = lazy(() => import("../motoland/Gmail/RequestPending"));


const TransactionIndex = lazy(() =>
  import("../motoland/transactions/TransactionsIndex")
);
const TransactionsCreate = lazy(() =>
  import("../motoland/transactions/TransactionsCreate")
);
const TransactionsForUser = lazy(() =>
  import("../motoland/transactions/TransactionsForUser")
);
const TransactionForUserShow = lazy(() =>
  import("../motoland/transactions/TransactionsForUserShow")
);

const AccountIndex = lazy(() => import("../motoland/account/AccountIndex"));

const VehicleMovement = lazy(() =>
  import("../motoland/vehiculos/VehicleMovement")
);

const MovementPending = lazy(() =>
  import("../motoland/movement/MovementPending")
);
const MovementDetails = lazy(() =>
  import("../motoland/movement/MovementDetails")
);
const MovementTechnicality = lazy(() =>
  import("../motoland/movement/MovementTechnicality")
);
const MovementIndex = lazy(() => import("../motoland/movement/MovementIndex"));
const MovementForm = lazy(() => import("../motoland/movement/MovementForm"));

const Warehouse = lazy(() => import("../motoland/warehouse/WareHouse"));
const WareHouseRed = lazy(() => import("../motoland/warehouse/WareHouseRed"));
const WareHouseAvaibleBill = lazy(() =>
  import("../motoland/warehouse/WareHouseAvaibleBill")
);

const BillBulk = lazy(() => import("../motoland/facturar/BillBulk"));

const IncomeList = lazy(() => import("../motoland/income/IncomeList"));
const IncomeForm = lazy(() => import("../motoland/income/IncomeForm"));
const IncomeFormSupervisor = lazy(() =>
  import("../motoland/income/IncomeFormSupervisor")
);
const IncomeListByOrder = lazy(() =>
  import("../motoland/income/IncomeListByOrder")
);
const IncomePending = lazy(() => import("../motoland/income/IncomeVerify"));
const IncomeDelete = lazy(() => import("../motoland/income/IncomeDelete"));
const IncomeControl = lazy(() => import("../motoland/income/IncomeControl"));
const IncomeEdit = lazy(() => import("../motoland/income/IncomeEdit"));
const IncomeReportBySupervisor = lazy(() =>
  import("../motoland/income/IncomeReportBySupervisor")
);
const IncomeReportByBussines = lazy(() =>
  import("../motoland/income/IncomeReportByBussines")
);

const PolicyList = lazy(() => import("../motoland/policy/PolicyList"));
const PolicyForm = lazy(() => import("../motoland/policy/PolicyForm"));
const PolicyGenerate = lazy(() => import("../motoland/policy/PolicyGenerate"));

const SouvenirsProductsList = lazy(() =>
  import("../motoland/SouvenirsProduct/SouvenirsProductList")
);
const SouvenirsProductsCreate = lazy(() =>
  import("../motoland/SouvenirsProduct/SouvenirsProductCreate")
);

const SouvenirsInventoryList = lazy(() =>
  import("../motoland/souvenirsInventory/SouvenirsInventoryList")
);
const SouvenirsInventoryCreate = lazy(() =>
  import("../motoland/souvenirsInventory/SouvenirsInventoryCreate")
);
const SouvenirsInventoryEdit = lazy(() =>
  import("../motoland/souvenirsInventory/SouvenirsInventoryEdit")
);

const SouvenirsOrder = lazy(() =>
  import("../motoland/souvenirs/SouvenirsOrder")
);
const SouvenirsInbox = lazy(() =>
  import("../motoland/souvenirs/SouvenirsInbox")
);
const SouvenirsApproved = lazy(() =>
  import("../motoland/souvenirs/SouvenirApproved")
);
const SouvenirsDetails = lazy(() =>
  import("../motoland/souvenirs/SouvenirsDetails")
);
const SouvenirEdit = lazy(() => import("../motoland/souvenirs/SouvenirEdit"));

const ServicesRequests = lazy(() =>
  import("../motoland/serviciosTecnico/ServicesRequests")
);
const ServicesUnlink = lazy(() =>
  import("../motoland/serviciosTecnico/ServicesUnlink")
);

const ServicesMaintenanceDetails = lazy(() =>
  import("../motoland/serviciosTecnico/ServicesMaintenanceDetails")
);

const ServicesMaintenenceReports = lazy(() =>
  import("../motoland/serviciosTecnico/ServicesMaintenenceReport")
);

const ServicesMaintenanceChasis = lazy(() =>
  import("../motoland/serviciosTecnico/ServicesMaintenanceChasis")
);
const ServicesRegisterMaintenance = lazy(() =>
  import("../motoland/serviciosTecnico/ServicesRegisterMaintenance")
);
const ServicesEditMaintenance = lazy(() =>
  import("../motoland/serviciosTecnico/ServicesEditMaintenance")
);
const WorkOrdersList = lazy(() =>
  import("../motoland/ordenesTrabajo/WorkOrdersList")
);
const WorkOrderChassisHistory = lazy(() =>
  import("../motoland/ordenesTrabajo/WorkOrderChassisHistory")
);
const WorkOrderDetail = lazy(() =>
  import("../motoland/ordenesTrabajo/WorkOrderDetail")
);
const WorkshopPayments = lazy(() =>
  import("../motoland/pagosTalleres/WorkshopPayments")
);
const MaintenancePlans = lazy(() =>
  import("../motoland/planMantenimiento/MaintenancePlans")
);
const MaintenancePlanEditor = lazy(() =>
  import("../motoland/planMantenimiento/MaintenancePlanEditor")
);
const MaintenanceRates = lazy(() =>
  import("../motoland/pagosTalleres/MaintenanceRates")
);

const AgentSucursalUnifiedCreate = lazy(() =>
  import("../motoland/agentes/AgentSucursalUnifiedCreate")
);
const AgentUnifiedEdit = lazy(() =>
  import("../motoland/agentes/AgentUnifiedEdit")
);

const Prospects = lazy(() => import("../motoland/prospectos/Prospects"));
const ProspectsExcel = lazy(() =>
  import("../motoland/prospectos/ProspectsExcel")
);
const ProspectsBySupervisor = lazy(() =>
  import("../motoland/prospectos/ProspectsBySupervisor")
);

// Nuevos componentes CRM
const CrmProspectsList = lazy(() => import("../motoland/prospectos/CrmProspectsList"));
const CrmProspectForm = lazy(() => import("../motoland/prospectos/CrmProspectForm"));

const CrmProspectDetails = lazy(() => import("../motoland/prospectos/CrmProspectDetails"));
const WhatsappInbox = lazy(() => import("../motoland/whatsapp/WhatsappInbox"));
const WhatsappDashboard = lazy(() => import("../motoland/whatsapp/WhatsappDashboard"));
const TestForm = lazy(() => import("../motoland/prospectos/TestForm"));

// Componentes del Sistema de Comisiones
const CommissionDashboard = lazy(() => import("../motoland/comisiones/CommissionDashboard"));
const CommissionPeriods = lazy(() => import("../motoland/comisiones/CommissionPeriods"));
const AgentEvaluation = lazy(() => import("../motoland/comisiones/AgentEvaluation"));
const BulkAgentEvaluation = lazy(() => import("../motoland/comisiones/BulkAgentEvaluation"));
const CategoriesManagement = lazy(() => import("../motoland/comisiones/CategoriesManagement"));

const Discount = lazy(() => import("../motoland/descuentos/Discount"));

const AgentVisit = lazy(() => import("../motoland/agentesVisitas/AgentVisit"));
const AgentVisitUser = lazy(() =>
  import("../motoland/agentesVisitas/AgentVisitSupervisor")
);
const AgentVisitManage = lazy(() =>
  import("../motoland/agentesVisitas/AgentVisitManage")
);

const ControlList = lazy(() => import("../motoland/MasterControl/ControlList"));

const ControlAccount = lazy(() =>
  import("../motoland/MasterAccount/ControlAccount")
);

const Inventory = lazy(() => import("../motoland/Inventory/Inventory"))
const NotificationCampaigns = lazy(() => import("../motoland/notificaciones/NotificationCampaigns"));
const CustomerAdvancesList = lazy(() => import("../motoland/adelantos/CustomerAdvancesList"));
const CustomerAdvanceForm = lazy(() => import("../motoland/adelantos/CustomerAdvanceForm"));

const formsRoutes = [
  {
    path: "/forms/basic",
    component: FormBasic,
  },
  {
    path: "/forms/action-bar",
    component: ActionBarForm,
  },
  {
    path: "/forms/layouts",
    component: LayoutForm,
  },
  {
    path: "/forms/multi-column-forms",
    component: MultiColumnForms,
  },
  {
    path: "/forms/input-group",
    component: InputGroupForm,
  },
  {
    path: "/forms/form-validation",
    component: FormValidation,
  },
  {
    path: "/forms/forms-wizard",
    component: FormsWizard,
  },
  {
    path: "/forms/form-editor",
    component: FormEditor,
  },
  {
    path: "/forms/tag-input",
    component: TagInput,
  },
  {
    path: "/container/create",
    component: ContainerCreate,
  },
  {
    path: "/container/:idcontainers/edit",
    component: ContainerEdit,
  },
  {
    path: "/container/show",
    component: ContainerShow,
  },
  {
    path: "/container/:idcontainers/detail",
    component: ContainerDetail,
  },
  {
    path: "/container/:idcontainers/units",
    component: ContainerUnits,
  },
  {
    path: "/container/eliminate",
    component: ContainerEliminate,
  },
  {
    path: "/container/extracted",
    component: ContainerExtracted,
  },
  {
    path: "/container/transit-inventory",
    component: ContainerTransitInventory,
  },
  {
    path: "/container/assembly-projection",
    component: AssemblyProjectionPage,
  },
  {
    path: "/armado/dashboard",
    component: AssemblyLineDashboard,
  },
  {
    path: "/armado/planificacion",
    component: MonthlyPlanningReport,
  },
  {
    path: "/container/:idcontainers/distribution",
    component: ContainerDistribution,
  },
  {
    path: "/distribution/create",
    component: DistributionCreate,
  },
  {
    path: "/distribution/show",
    component: DistributionShow,
  },
  {
    path: "/distribution/units",
    component: DistributionUnits,
  },
  {
    path: "/distribution/:iddistribution/edit",
    component: DistributionEdit,
  },
  {
    path: "/assembly/show",
    component: AssemblyShow,
  },
  {
    path: "/assembly/work-codes",
    component: WorkCodesShow,
  },
  {
    path: "/assembly/create",
    component: AssemblyCreate,
  },
  {
    path: "/assembly/units",
    component: AssemblyUnits,
  },
  {
    path: "/assembly/:idassembly/edit",
    component: AssemblyEdit,
  },
  {
    path: "/assembly/search",
    component: AssemblyReject,
  },
  {
    path: "/survey/templates",
    component: SurveyTemplates,
  },
  {
    path: "/survey/fill",
    component: SurveyFill,
  },
  {
    path: "/survey/tracking",
    component: SurveyTracking,
  },
  {
    path: "/survey/supervisor-targets",
    component: SupervisorTargets,
  },
  {
    path: "/survey/supervisor-compliance",
    component: SupervisorCompliance,
  },
  {
    path: "/vehicle/show",
    component: VehicleShow,
  },
  {
    path: "/vehicle/create",
    component: VehicleCreate,
  },
  {
    path: "/vehicle/costs",
    component: VehicleCostManager,
  },
  {
    path: "/vehicle/:idvehicle/edit",
    component: VehicleEdit,
  },
  {
    path: "/vehicle/send",
    component: VehicleSend,
  },
  {
    path: "/vehicle/sendmassive",
    component: VehicleSendMassive,
  },
  {
    path: "/vehicle/distribution",
    component: VehicleSendDistribution,
  },
  {
    path: "/vehicle/assembly",
    component: VehicleSendAssembly,
  },
  {
    path: "/vehicle/orders",
    component: VehicleOrder,
  },
  {
    path: "/vehicle/change",
    component: VehicleChangeData,
  },
  {
    path: "/vehicle/ship/:idshipping",
    component: VehicleShowOrder,
  },
  {
    path: "/agent/show",
    component: AgentShow,
  },
  {
    path: "/agent/annex",
    component: AgentAnnex,
  },
  {
    path: "/vehicle/follow",
    component: VehicleFollow,
  },
  {
    path: "/vehicle/reception",
    component: VehicleReceptionDistribution,
  },
  {
    path: "/vehicle/unlink",
    component: VehicleUnlink,
  },
  {
    path: "/vehicle/:id/units",
    component: VehicleFormEdit,
  },
  {
    path: "/reception/assembly",
    component: VehicleReceptionAssembly,
  },
  {
    path: "/agent/create",
    component: AgentCreate,
  },
  {
    path: "/agent/create-unified",
    component: AgentSucursalUnifiedCreate,
  },
  {
    path: "/agent/:idagent/edit",
  component: AgentUnifiedEdit,
  },
  {
    path: "/agent/:id/documents",
    component: AgentDocuments,
  },
  {
    path: "/agent/units",
    component: AgentUnits,
  },
  {
    path: "/agent/history",
    component: AgentSalesHistory,
  },
  {
    path: "/agent/pay",
    component: AgentPay,
  },
  {
    path: "/agent/:idshippingdetail/detail",
    component: AgentDetailUnits,
  },
  {
    path: "/agent/report",
    component: AgentReport,
  },
  {
    path: "/agent/report2",
    component: AgentReportAgent,
  },
  {
    path: "/agent/report3",
    component: AgentReportGlobal,
  },
  {
    path: "/agent/report4",
    component: AgentReportSinFacturar,
  },
  {
    path: "/agent/report5",
    component: AgentReportCredit,
  },
  {
    path: "/agent/report6",
    component: AgentReportVoucher,
  },
  {
    path: "/agent/income",
    component: AgentUnitsIncome,
  },
  {
    path: "/sucursal/index",
    component: SucursalIndex,
  },
  {
    path: "/sucursal/create",
    component: SucursalCreate,
  },
  {
    path: "/bill/index",
    component: CreateBill,
  },
  {
    path: "/bill/list",
    component: BillList,
  },
  {
    path: "/bill/reject",
    component: BillReject,
  },
  {
    path: "/bill/pending",
    component: BillListPending,
  },
  {
    path: "/bill/:id/details",
    component: BillDetail,
  },
  {
    path: "/bill/:idbill/generate",
    component: BillGenerator,
  },
  {
    path: "/units/bill/reports",
    component: BillReport,
  },
  {
    path: "/units/bill/user",
    component: BillReportBySupervisor,
  },
  {
    path: "/raffle/tickets",
    component: RaffleTickets,
  },
  {
    path: "/pay/index",
    component: PayIndex,
  },
  {
    path: "/pay/:id/order",
    component: PayUnit,
  },
  {
    path: "/pay/show",
    component: PayShow,
  },
  {
    path: "/pay/voucher",
    component: PayVoucher,
  },
  {
    path: "/pay/:idunits/detail",
    component: PayVoucherDetail,
  },
  {
    path: "/user/create",
    component: UserCreate,
  },
  {
    path: "/user/show",
    component: UserShow,
  },
  {
    path: "/user/permissions",
    component: UserPermissions,
  },
  {
    path: "/user/:iduser/edit",
    component: UserEdit,
  },
  {
    path: "/orders/create",
    component: OrderCreate,
  },
  {
    path: "/orders/used",
    component: OrderCreateUsed,
  },
  {
    path: "/orders/pending",
    component: RequestPending,
  },
  {
    path: "/orders/detail/:idorders",
    component: DetailOrder,
  },
  {
    path: "/orders/charged",
    component: ApproveOrder,
  },
  {
    path: "/orders/:idorders/load",
    component: LoadOrders,
  },
  {
    path: "/orders/myorders",
    component: MyOrders,
  },
  {
    path: "/orders/:idorders/show",
    component: OrderLoaded,
  },
  {
    path: "/orders/:idorders/bill",
    component: OrdersDetailsByBill,
  },
  {
    path: "/orders/:idorders/edit",
    component: OrdersEdit,
  },
  {
    path: "/orders/dispatch",
    component: OrdersDispatch,
  },
  {
    path: "/orders/preview",
    component: OrdersPreview,
  },
  {
    path: "/orders/accounting",
    component: OrdersAccounting,
  },
  {
    path: "/orders/master",
    component: OrdersMasterControl,
  },
  {
    path: "/orders/:id/viewer",
    component: OrdersViewer,
  },
  {
    path: "/orders/:id/photo",
    component: OrdersPhoto,
  },
  {
    path: "/dispatch/:id/preview",
    component: OrdersDispatchPreview,
  },
  {
    path: "/orders/:idorders/dispatch",
    component: OrdersDispatchLoad,
  },
  {
    path: "/orders/:idorders/generate",
    component: OrdersDispatchGenerate,
  },
  {
    path: "/transaction/index",
    component: TransactionIndex,
  },
  {
    path: "/transaction/user",
    component: TransactionsForUser,
  },
  {
    path: "/transaction/show/user",
    component: TransactionForUserShow,
  },
  {
    path: "/transaction/create",
    component: TransactionsCreate,
  },
  {
    path: "/user/setting/index",
    component: UserSettings,
  },
  {
    path: "/user/setting/create",
    component: UserSettingsCreate,
  },
  {
    path: "/user/manager/index",
    component: UserManager,
  },
  {
    path: "/account/agent",
    component: AccountIndex,
  },
  {
    path: "/vehicle/movement",
    component: VehicleMovement,
  },
  {
    path: "/movement/pending",
    component: MovementPending,
  },
  {
    path: "/movement/index",
    component: MovementIndex,
  },
  {
    path: "/movement/:id/technicality",
    component: MovementTechnicality,
  },
  {
    path: "/movement/:id/form",
    component: MovementForm,
  },
  {
    path: "/warehouse/all",
    component: Warehouse,
  },
  {
    path: "/warehouse/red",
    component: WareHouseRed,
  },
  {
    path: "/warehouse/bill",
    component: WareHouseAvaibleBill,
  },
  {
    path: "/bulk",
    component: BillBulk,
  },
  {
    path: "/income/list",
    component: IncomeList,
  },
  {
    path: "/income/create",
    component: IncomeForm,
  },
  {
    path: "/income/:id/edit",
    component: IncomeEdit,
  },
  {
    path: "/income/pending",
    component: IncomePending,
  },
  {
    path: "/income/delete",
    component: IncomeDelete,
  },
  {
    path: "/income/control",
    component: IncomeControl,
  },
  {
    path: "/income/:id/orders",
    component: IncomeFormSupervisor,
  },
  {
    path: "/income/:id/list",
    component: IncomeListByOrder,
  },
  {
    path: "/income/reports/supervisor",
    component: IncomeReportBySupervisor,
  },
  {
    path: "/income/reports/business",
    component: IncomeReportByBussines,
  },
  {
    path: "/policy/list",
    component: PolicyList,
  },
  {
    path: "/policy/create",
    component: PolicyForm,
  },
  {
    path: "/policy/generate",
    component: PolicyGenerate,
  },
  {
    path: "/souvenirsproducts/list",
    component: SouvenirsProductsList,
  },
  {
    path: "/souvenirsproducts/create",
    component: SouvenirsProductsCreate,
  },
  {
    path: "/souvenirsinventory/list",
    component: SouvenirsInventoryList,
  },
  {
    path: "/souvenirsinventory/create",
    component: SouvenirsInventoryCreate,
  },
  {
    path: "/souvenirsinventory/:id/edit",
    component: SouvenirsInventoryEdit,
  },
  {
    path: "/souvenirsorder/create",
    component: SouvenirsOrder,
  },
  {
    path: "/souvenirsorder/inbox",
    component: SouvenirsInbox,
  },
  {
    path: "/souvenirsorder/approved",
    component: SouvenirsApproved,
  },
  {
    path: "/souvenirsorder/:id/details",
    component: SouvenirsDetails,
  },
  {
    path: "/souvenirsorder/:id/edit",
    component: SouvenirEdit,
  },
  {
    path: "/services/pending",
    component: ServicesRequests,
  },
  {
    path: "/services/unlink",
    component: ServicesUnlink,
  },
  {
    path: "/maintenance/:id/viewer",
    component: ServicesMaintenanceDetails,
  },
  {
    path: "/maintenance/:id/edit",
    component: ServicesEditMaintenance,
  },
  {
    path: "/maintenance/reports",
    component: ServicesMaintenenceReports,
  },
  {
    path: "/maintenance/create",
    component: ServicesRegisterMaintenance,
  },
  {
    path: "/services/historial",
    component: ServicesMaintenanceChasis,
  },
  {
    path: "/workorders/history",
    component: WorkOrderChassisHistory,
  },
  {
    path: "/workorders/:id",
    component: WorkOrderDetail,
  },
  {
    path: "/workorders",
    component: WorkOrdersList,
  },
  {
    path: "/maintenance-plans/:id",
    component: MaintenancePlanEditor,
  },
  {
    path: "/maintenance-plans",
    component: MaintenancePlans,
  },
  {
    path: "/workshop-payments/rates",
    component: MaintenanceRates,
  },
  {
    path: "/workshop-payments",
    component: WorkshopPayments,
  },
  {
    path: "/prospects/list",
    component: Prospects,
  },
  {
    path: "/prospects/supervisor",
    component: ProspectsBySupervisor,
  },
  {
    path: "/prospects/upload",
    component: ProspectsExcel,
  },
  // Nuevas rutas del CRM - ORDEN IMPORTANTE: rutas específicas antes que parámetros
  {
    path: "/crm/prospects",
    component: CrmProspectsList,
    exact: true,
  },
  {
    path: "/crm/prospects/create",
    component: CrmProspectForm,
  },
  {
    path: "/crm/prospects/:id/edit",
    component: CrmProspectForm,
  },
  {
    path: "/crm/prospects/:id",
    component: CrmProspectDetails,
  },
  // Chat de WhatsApp (motor Chatwoot) dentro de Vehiculos
  {
    path: "/whatsapp",
    component: WhatsappInbox,
    exact: true,
  },
  {
    path: "/whatsapp/dashboard",
    component: WhatsappDashboard,
    exact: true,
  },
  {
    path: "/whatsapp/:id",
    component: WhatsappInbox,
  },
  {
    path: "/discount/list",
    component: Discount,
  },
  {
    path: "/agentvisit/list",
    component: AgentVisit,
  },
  {
    path: "/agentvisit/user/list",
    component: AgentVisitUser,
  },
  {
    path: "/agentvisit/:id/manage",
    component: AgentVisitManage,
  },
  {
    path: "/control/list",
    component: ControlList,
  },
  {
    path: "/control/account",
    component: ControlAccount,
  },
  {
    path: "/inventory",
    component: Inventory
  },
  {
    path: "/notifications/campaigns",
    component: NotificationCampaigns,
    exact: true,
  },
  {
    path: "/customer-advances",
    component: CustomerAdvancesList,
    exact: true,
  },
  {
    path: "/customer-advances/create",
    component: CustomerAdvanceForm,
    exact: true,
  },
  {
    path: "/customer-advances/:id/edit",
    component: CustomerAdvanceForm,
    exact: true,
  },
  // Rutas del Sistema de Comisiones
  {
    path: "/commission/dashboard",
    component: CommissionDashboard,
    exact: true,
  },
  {
    path: "/commission/periods",
    component: CommissionPeriods,
    exact: true,
  },
  {
    path: "/commission/evaluations/:periodId",
    component: AgentEvaluation,
    exact: true,
  },
  {
    path: "/commission/bulk-evaluations/:periodId",
    component: BulkAgentEvaluation,
    exact: true,
  },
  {
    path: "/commission/categories",
    component: CategoriesManagement,
    exact: true,
  }
];

export default formsRoutes;
